import React from 'react';

import withExtraProps from '../../utils/with-extra-props';
import SwitchIconsCommon from './portfolio-header-switch-common';

import './portfolio-header-switch.css';

export default withExtraProps(() => ({
  containerProps: {
    className: 'portfolio-header',
  },
  iconsProps: {
    className: 'portfolio-header__icons',
  }
}))(SwitchIconsCommon);
